import { styled } from '@mui/material/styles';
import { Datagrid } from 'shared/react-admin/Datagrids';
import { getColumnStyle } from 'utils';

export const StyledDatagrid = styled(Datagrid)({
  '& .MuiTableCell-root': {
    verticalAlign: 'middle',
  },
  '& .RaDatagrid-headerCell': {
    padding: '7px 16px',
  },
  '& .RaDatagrid-rowCell': {
    padding: '16px',
  },
  '& .column-disputeStatus': getColumnStyle(136),
  '& .column-openedAt': getColumnStyle(118),
  '& .column-closedAt': getColumnStyle(118),
  '& .column-openReason': { maxWidth: '320px' },
});
